import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";
import router from "../../../../router";

const saveInvoice = {
    namespaced: true,
    state: {
        dataSaveIsFetching: false,
        dataStoreAndSendIsFetching: false,
        textInfoInvoiceSave: "",
        typeInfoInvoiceSave: "",
        headInfoInvoiceSave: "",
        isInvoiceSave: false,
        isModalSendInvoiceVisible: false,
        invoiceItems: [],
        invoiceId: null

    },
    mutations: {
        DATA_SAVE_REQUEST(state, value) {
            state.dataSaveIsFetching = value;
        },
        STORE_AND_SEND_REQUEST(state, value) {
            state.dataStoreAndSendIsFetching = value;
        },
        DATA_SAVE_SUCCESS(state, response) {
            state.typeInfoInvoiceSave = "green";
            state.headInfoInvoiceSave = response.data.message;
            state.textInfoInvoiceSave = response.data.data.textInfo;
            state.dataSaveIsFetching = false;
            state.isInvoiceSave = true;
            eventBus.$emit("saveInvoiceSuccess", response.data);
            if (router.currentRoute.name === 'ProjectsEdit') {
                eventBus.$emit('refreshProjectData');
            }
        },
        DATA_SAVE_FAILURE(state, error) {
            if (error.response.data.errors.type && error.response.data.errors.type[0] === 'diskLimitExceeded') {
                state.dataSaveIsFetching = false;
                eventBus.$emit('projectDiskLimitExceeded', error.response.data.errors);
            } else {
                state.textInfoInvoiceSave = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
                state.typeInfoInvoiceSave = "red";
                state.headInfoInvoiceSave = error.response.data.message;
                state.isInvoiceSave = true;
                state.dataSaveIsFetching = false;
                eventBus.$emit("saveInvoiceFailure", error.response.data.errors);
            }     
        },
        STORE_AND_SAVE_SUCCESS(state, response) {
            state.invoiceId = response.data.data.invoiceId
            state.dataStoreAndSendIsFetching = false;
            state.isModalSendInvoiceVisible = true;
            eventBus.$emit("storeAndSendInvoiceSuccess");
        },
        STORE_AND_SAVE_FAILURE(state, error) {
            if (error.response.data.errors.type && error.response.data.errors.type[0] === 'diskLimitExceeded') {
                state.dataStoreAndSendIsFetching = false;
                eventBus.$emit('projectDiskLimitExceeded', error.response.data.errors);
            } else {
                state.textInfoInvoiceSave = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
                state.typeInfoInvoiceSave = "red";
                state.headInfoInvoiceSave = error.response.data.message;
                state.isInvoiceSave = true;

                state.isModalSendInvoiceVisible = false;
                state.dataStoreAndSendIsFetching = false;
                eventBus.$emit("saveInvoiceFailure", error.response.data.errors);
            }        
        },
        UPDATE_VISIBLE_MODAL(state, value) {
            state.isInvoiceSave = value;
        },
        PREPARE_INVOICE_ITEMS(state, items) {
            state.invoiceItems = items;
        },
        HIDE_MODAL_SEND_INVOICE(state, value) {
            state.isModalSendInvoiceVisible = value;
        }
    },
    actions: {
        storeInvoice: function({ dispatch, state }, payload) {
            let url = new URL(window.location.href);
            if(payload.creds.projectId == null) {
                if(payload.creds.modelType === 'invoice') {
                    payload.creds.projectId = payload.creds.project.id;
                } else {
                    payload.creds.projectId = url.searchParams.get("id");
                }
            }
            payload.creds.invoiceItems = state.invoiceItems;
            dispatch("requestDataSave", true);
            let promise = sendRequest("post", config.baseURLApi + "/invoices", {}, payload.creds);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataSave", result[1]);

                } else {
                    dispatch("failureDataSave", result[1]);
                }
            });
        },
        storeInvoiceAndSend: function({ dispatch, state }, payload) {
            let url = new URL(window.location.href);
            if(payload.creds.projectId == null) {
                if(payload.creds.modelType === 'invoice') {
                    payload.creds.projectId = payload.creds.project.id;
                } else {
                    payload.creds.projectId = url.searchParams.get("id");
                }
            }
            payload.creds.invoiceItems = state.invoiceItems;
            dispatch("requestStoreAndSend", true);
            let promise = sendRequest("post", config.baseURLApi + "/invoices", {}, payload.creds);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successStoreAndSend", result[1]);
                } else {
                    dispatch("failureStoreAndSend", result[1]);
                }
            });
        },
        prepareInvoiceItems: function ({commit}, items) {
            commit("PREPARE_INVOICE_ITEMS", items)
        },
        requestDataSave: function({ commit }, value) {
            commit("DATA_SAVE_REQUEST", value);
        },
        requestStoreAndSend: function({ commit }, value) {
            commit("STORE_AND_SEND_REQUEST", value);
        },
        successDataSave: function({ commit }, response) {
            commit("DATA_SAVE_SUCCESS", response);
        },
        failureDataSave: function({ commit }, error) {
            commit("DATA_SAVE_FAILURE", error);
        },
        successStoreAndSend: function({ commit }, response) {
            commit("STORE_AND_SAVE_SUCCESS", response);
        },
        failureStoreAndSend: function({ commit }, error) {
            commit("STORE_AND_SAVE_FAILURE", error);
        },
        updateVisibleModal: function({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL", value);
        },
        hideSendInvoiceModalRequest: function({ commit }, value) {
            commit("HIDE_MODAL_SEND_INVOICE", value)
        }
    }
}

export default saveInvoice;